import { z } from "zod";

export const OnboardingSmartPOSItemSchema = z.object({
  Completed: z.boolean().optional(),
  Available: z.boolean().optional(),
  DeliveryCompleted: z.boolean().optional(),
  DeliveryStatus: z.string().optional(),
  TrackingNumber: z.string().optional(),
  TrackingLink: z.string().optional(),
  Activated: z.boolean().optional(),
  BusinessUnitProductId: z.string().optional(),
});

export type OnboardingSmartPOSItemType = z.infer<
  typeof OnboardingSmartPOSItemSchema
>;
